import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArchivoService {

  constructor(private http: HttpClient) { }

  /**
   * Descarga un archivo por tabla e id_tabla
   * @param tabla Nombre de la tabla
   * @param idTabla ID del registro en la tabla
   * @returns Observable con el blob del archivo
   */
  descargarArchivo(tabla: string, idTabla: number): Observable<Blob> {
    return this.http.get(
      `${properties.URL_CATALOGS}archivos/descargar/${tabla}/${idTabla}`,
      {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        }),
        responseType: 'blob'
      }
    );
  }

  /**
   * Busca información de un archivo por tabla e id_tabla
   * @param tabla Nombre de la tabla
   * @param idTabla ID del registro en la tabla
   * @returns Observable con la información del archivo
   */
  buscarArchivo(tabla: string, idTabla: number): Observable<any> {
    return this.http.get<any>(
      `${properties.URL_CATALOGS}archivos/buscar/${tabla}/${idTabla}`,
      properties.httpOptions
    );
  }

  /**
   * Guarda un archivo en formato base64
   * @param data Objeto con file_base64, tabla, id_tabla, file_name, id_colaborador
   * @returns Observable con la respuesta
   */
  guardarArchivoBase64(data: any): Observable<any> {
    return this.http.post<any>(
      `${properties.URL_CATALOGS}archivos/base64`,
      data,
      properties.httpOptions
    );
  }

  /**
   * Descarga un archivo y lo guarda automáticamente
   * @param tabla Nombre de la tabla
   * @param idTabla ID del registro en la tabla
   * @param nombreArchivo Nombre opcional para el archivo descargado
   */
  descargarYGuardarArchivo(tabla: string, idTabla: number, nombreArchivo?: string): void {
    // Primero buscar la información del archivo para obtener el mime y nombre original
    this.buscarArchivo(tabla, idTabla).subscribe({
      next: (response) => {
        if (response.success && response.archivo) {
          const archivoInfo = response.archivo;
          const mime = archivoInfo.mime;
          const nombreOriginal = archivoInfo.file_name;
          console.log('Información del archivo:', archivoInfo);
          // Determinar la extensión según el mime type
          let extension = '';
          switch (mime) {
            case 'image/png':
              extension = '.png';
              break;
            case 'image/jpeg':
            case 'image/jpg':
              extension = '.jpg';
              break;
            case 'image/gif':
              extension = '.gif';
              break;
            case 'image/webp':
              extension = '.webp';
              break;
            case 'application/pdf':
              extension = '.pdf';
              break;
            default:
              extension = '';
          }
          
          console.log('MIME:', mime, 'Extension:', extension);
          
          // Función auxiliar para remover extensión existente
          const removeExtension = (filename: string): string => {
            const lastDot = filename.lastIndexOf('.');
            return lastDot > 0 ? filename.substring(0, lastDot) : filename;
          };
          
          // Determinar el nombre final del archivo
          let finalFileName: string;
          if (nombreArchivo) {
            // Si se proporciona nombre personalizado, remover extensión antigua y usar la correcta
            const nombreSinExtension = removeExtension(nombreArchivo);
            finalFileName = nombreSinExtension + extension;
          } else if (nombreOriginal) {
            // Usar el nombre original pero con la extensión correcta según el mime
            const nombreSinExtension = removeExtension(nombreOriginal);
            finalFileName = nombreSinExtension + extension;
          } else {
            // Nombre por defecto con extensión correcta
            finalFileName = `archivo_${tabla}_${idTabla}${extension}`;
          }
          
          console.log('Nombre final del archivo:', finalFileName);
          
          // Ahora descargar el archivo
          this.descargarArchivo(tabla, idTabla).subscribe({
            next: (blob: Blob) => {
              // Crear URL temporal para el blob
              const url = window.URL.createObjectURL(blob);
              
              // Crear elemento <a> temporal para descargar
              const link = document.createElement('a');
              link.href = url;
              link.download = finalFileName;
              
              // Simular click para descargar
              document.body.appendChild(link);
              link.click();
              
              // Limpiar
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            },
            error: (error) => {
              console.error('Error al descargar el archivo:', error);
              alert('Error al descargar el archivo. Por favor intente nuevamente.');
            }
          });
        } else {
          alert('No se encontró el archivo solicitado.');
        }
      },
      error: (error) => {
        console.error('Error al buscar información del archivo:', error);
        alert('Error al obtener información del archivo. Por favor intente nuevamente.');
      }
    });
  }
}
